module.exports = __webpack_public_path__ + "static/header-70d27f1faee7cc381fc61a19ff9ea421.png";